import React from "react";
import { Box, Text, Mark, Container, Grid, createStyles } from '@mantine/core';

const useStyles = createStyles((theme) => ({
    oLi: {
        '&>li': {
            marginBottom: '.75rem',
        },
        '& li:not(&>li)': {
            marginBottom: '.25rem',
        },
    },
}));

const KetentuanGaransi = () => {

    const { classes } = useStyles();

    return (
        <React.Fragment>
            <Container fluid>
                <Grid>
                    <Grid.Col span={12}>
                        <Box mt='2rem' mb='50vh'>
                            <ol
                                className={classes.oLi}
                            >
                                <li>
                                    <Text>Klaim bisa dilakukan pada :</Text>
                                    <ol>
                                        <li>Di setiap step proses pengerjaan. Jika prosesnya sudah bukan di step pengerjaan, mundurkan step ke step pengerjaan terlebih dahulu.</li>
                                        <li>Dimodul klaim garansi (khusus untuk garansi atas nama customer) - Pilih customer, lalu pilih item di transaksi mana yang akan di klaim</li>
                                    </ol>
                                </li>
                                <li>Item yg diklaim masuk kedalam modul klaim</li>
                                <li>Jika akan diklaim, muncul isian tanggal berapa diklaimnya</li>
                                <li>Jika sudah diklaim, confirm bahwa itemnya sudah sampai dan nambah stok lagi</li>
                                <li>Item yang diklaim, tanggalnya tidak boleh berubah</li>
                                <li>Properti pernah klaim garansi akan tercatat di dirinya sendiri di sub menu stok. <Mark>(Maksudnya "di sub menu stok" apa?)</Mark></li>
                                <li>
                                    <Text>Pembatalan penggunaan item ada 3 :</Text>
                                    <ol>
                                        <li>Karena salah pilih</li>
                                        <li>Karena item tersebut rusak tapi tidak bisa diklaim (Masuk ke list barang rusak non repairable)</li>
                                        <li>Karena item tersebut rusak dan bisa diklaim (mekanisme garansi)</li>
                                    </ol>
                                </li>

                                <li>
                                    <Text>Klaim ga selalu baliknya berupa item/barang lagi. Hasil dari klaim ke supplier bisa berupa :</Text>
                                    <ol>
                                        <li>Item. Serial number bisa sama bisa juga berubah. Jika berubah, harus bisa ubah serial number yg baru</li>
                                        <li>Uang (Refund). Hapus stok/kurangi stok</li>
                                    </ol>
                                </li>

                                <li>Ada garansi yang life time(seumur hidup) atau berjangka (bulan, tahun)</li>
                                <li>Barang yang bisa diklaim belum tentu memiliki serial number</li>
                                <li>Garansi dimulai dari "Selesai Project"</li>
                                <li>Di modul garansi harus bisa input foto sebelum dan sesudah di klaim</li>
                                <li>Tanggal pengiriman harus editable</li>

                                <li>
                                    <Text>Klaim garansi ada yang atas nama Lumos dan atas nama Customer :</Text>
                                    <ol>
                                        <li>Atas nama Lumos; jika item tersebut masih dalam "Proses Pengerjaan" hingga proses "Selesai Project". Artinya item tersebut masih dalam tanggung jawab Lumos.</li>
                                        <li>Atas nama Customer; jika item tersebut sudah diambil oleh customer. Jika item tersebut rusak setelah pengambilan dari Lumos, item yg claimable tersebut dapat diklaim di Lumos namun atas nama Customer.</li>
                                    </ol>
                                </li>

                                <li>
                                    Nambah master supplier untuk rumah "jumlah_klaim" <Mark>(hubungannya apa antara master supplier dengan field "jumlah_klaim" ?)</Mark>
                                </li>

                                <li>Tambah field supplier di card stok modul garansi <Mark>(maksudnya gimana ?)</Mark></li>
                                <li>
                                    <Text>
                                        Kalau ga claimable, tampilkan notif/info bahwa item tersebut tidak bisa di klaim karena :
                                    </Text>

                                    <ol>
                                        <li>Memang tidak claimable</li>
                                        <li>Masa garansi sudah habis</li>
                                    </ol>
                                </li>

                                <li>Kalau beda supplier, harus bisa klaim sesuai suppliernya</li>
                                <li>Harus bisa input jumlah yang akan di klaim</li>
                                <li>Tampilannya kurang lebih seperti modul Pick Up item pada saat pengerjaan</li>

                                <li>
                                    <Text>Progress klaim :</Text>

                                    <ol>
                                        <li>Menunggu klaim</li>
                                        <li>Sedang klaim</li>
                                        <li>Selesai klaim</li>
                                    </ol>
                                </li>

                                <li>
                                    <Text>Contoh kasus. Jika ada 3 item yg diklaim di supplier yg sama dan yang dikembalikan yaitu 2 item dulu, maka :</Text>

                                    <ol>
                                        <li>Input yg 2 item ini sebagai item selesai di klaim</li>
                                        <li>Yang 1 lagi biarin aja karena masih proses klaim</li>
                                    </ol>
                                </li>

                                <li>
                                    <Text>Kemungkinan klaim :</Text>

                                    <ol>
                                        <li>
                                            Customer masih bisa klaim, dan supplier juga masih bisa klaim. Maka item tersebut masih bisa diklaim sesuai mekanisme klaim.
                                        </li>

                                        <li>
                                            Customer masih bisa klaim, tapi supplier sudah tidak bisa klaim. Maka dapat diklaim dengan kebijakan Lumos.
                                        </li>
                                    </ol>
                                </li>

                                <li>
                                    Di modul pick up item di proses pengerjaan, harus menampilkan kepemilikan item yg sudah selesai di klaim. Karena bisa jadi item yang sudah selesai diklaim tersebut sudah tagged punya customer, agar tidak di pick up oleh teknisi lain.
                                </li>
                            </ol>
                        </Box>
                    </Grid.Col>
                </Grid>
            </Container>
        </React.Fragment>
    )
}

export default KetentuanGaransi;